import type { AnchorHTMLAttributes } from 'react'

import './TecmaFeatureCard.css'

type TecmaFeatureCardProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  eyebrow: string
  title: string
  description: string
}

function ArrowIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4" aria-hidden="true">
      <path d="M4.167 10h11.666M10.833 4.167 15.833 10l-5 5.833" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function TecmaFeatureCard({ eyebrow, title, description, className = '', ...props }: TecmaFeatureCardProps) {
  return (
    <a
      {...props}
      className={`tecma-feature-card group block p-6 ${className}`.trim()}
    >
      <p className="tecma-feature-card__eyebrow text-xs font-black uppercase tracking-[0.24em]">{eyebrow}</p>
      <div className="mt-4 flex items-start justify-between gap-4">
        <h3 className="tecma-feature-card__title max-w-sm text-2xl font-black uppercase leading-tight">{title}</h3>
        <span className="tecma-feature-card__arrow mt-1 grid h-9 w-9 place-items-center transition">
          <ArrowIcon />
        </span>
      </div>
      <p className="tecma-feature-card__description mt-4 max-w-md text-sm leading-7">{description}</p>
    </a>
  )
}
